import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { Gear, PersonCircle } from "react-bootstrap-icons";
// import { useNavigate } from "react-router-dom";
// import logo from './imeges/logo1.png'
import NavBar from "./NavBar";
import { useTheme } from "./ThemeContext";
import Footer from "./Footer";
import customerpageimg from './imeges/customerpageimg.jpeg'

const Customer = () => {
  const [isSignIn, setIsSignIn] = useState(true);
  //  const navigate = useNavigate()
   const {theme}  = useTheme()
  // const handleNavClick = (section) => {
  //   if (window.location.pathname !== "/") {
  //     navigate("/");
  //     setTimeout(() => {
  //       window.location.href = `/#${section}`;
  //     }, 100);
  //   } else {
  //     document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
  //   }
  //   // setShowSidebar(false);
  // };

  return (
    <>
    <Container  fluid className="min-vh-100 d-flex flex-column" style={{
      backgroundColor: theme === "dark" ? "#1e1e1e" : "",
      minHeight: "100vh", 
    }}>
      {/* Navbar */}
      {/* <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: "#001351" }}>
        <div className="container"> */}
          {/* <a className="navbar-brand text-white fw-bold" href="#">Bot Bridge Technologies</a> */}
          {/* <Navbar.Brand href="#" className="me-lg-3">
            <img
              src={logo}
              loading="lazy"
              width="90"
              height="60"
              className="d-inline-block align-top"
              alt="IT Company logo"
            />
          </Navbar.Brand>
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><button className="btn btn-link nav-link text-white" onClick={() => handleNavClick("/")}>Home</button></li>
              <li className="nav-item"><button className="btn btn-link nav-link text-white" onClick={() => handleNavClick("about")}>About</button></li>
              <li className="nav-item"><button className="btn btn-link nav-link text-white" onClick={() => handleNavClick("services")}>services</button></li>
              <li className="nav-item"><button className="btn btn-link nav-link text-white" onClick={() => handleNavClick("contact")}>Contact</button></li>
            </ul>
          </div> */}
          {/* Top Right Icons */}
          {/* <div className="d-flex gap-3">
            <Gear className="text-white fs-4 cursor-pointer" />
            <PersonCircle className="text-white fs-4 cursor-pointer" />
          </div>
        </div>
      </nav> */}

      <NavBar />

      {/* Main Content */}
      <Container className="flex-grow-1 d-flex align-items-center justify-content-center  mt-5" >
        <Row className="shadow-lg rounded overflow-hidden" style={{ maxWidth: "900px", width: "100%", backgroundColor: "white" }}>
          
          {/* Left Section with Image */}
          <Col
  md={5} 
  className="p-4 d-flex flex-column align-items-center text-white "
  style={{ backgroundColor: "#222" }}
>
  <h3 className="fw-bold">Customer Login</h3>
  <p>We are here to help you!</p>
  <div
    className="rounded mt-3"
    style={{
      backgroundColor: "none",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    }}
  >
    <img
      src={customerpageimg}
      alt="Customer"
      className="img-fluid "
      style={{ transform: "scaleX(-1)", width: "100%", height: "100%" }}
    />
  </div>
  {/* Social Media Icons */}
  <div className="d-flex gap-3 mt-4">
    <i className="bi bi-twitter text-white fs-4"></i>
    <i className="bi bi-instagram text-white fs-4"></i>
    <i className="bi bi-discord text-white fs-4"></i>
  </div>
</Col>

          {/* Right Section with Form */}
          <Col md={7} className="p-4" >
            {/* Sign In & Sign Up Tabs Styled as Buttons */}
            <div className="d-flex">
              <Button 
                className={`flex-grow-1 ${isSignIn ? "btn-info" : "btn-dark"}`} 
                onClick={() => setIsSignIn(true)}
              >
                Sign In
              </Button>
              <Button 
                className={`flex-grow-1 ${!isSignIn ? "btn-info" : "btn-dark"}`} 
                onClick={() => setIsSignIn(false)}
              >
                Sign Up
              </Button>
            </div>

            {isSignIn ? (
              <Form className="mt-4 text-dark">
                <Form.Group className="mb-3 " >
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Enter password" />
                </Form.Group>
                <Button className="w-100 btn-dark">Login</Button>
              </Form>
            ) : (
              <Form className="mt-4 text-dark">
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control type="text" placeholder="First Name" />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control type="text" placeholder="Last Name" />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control type="text" placeholder="+1 012 3456 789" />
                </Form.Group>
                <Button className="w-100 btn-dark">Send OTP</Button>
              </Form>
            )}
          </Col>
        </Row>
      </Container>
    </Container>
    <Footer/>
  </>
  );
};

export default Customer;
